import { useContext } from 'react'
import { RedirectContext } from '../context/RedirectContext'

const useRedirect = () => useContext(RedirectContext)

export default useRedirect